import { BaseDataService } from "../../../services/base/BaseDataService";
import { hasEmbeddedDataImage, withUploadRejectionDetection } from '../../../helpers/uploadRequestRejection';
import { NoteActionDto } from "../../../types/requests/NoteActionDto";
import { PDFNoteQuery } from "../models/PDFNoteQuery";
import { PDFNote } from "../models/PDFNote";
import { AxiosPromise, CancelToken } from "axios";
import { DownloadNotesRegistryDto } from "../models/DownloadNotesRegistryDto";
import { PDFNoteRefreshPageRequest, PDFNoteRefreshPageResponse } from '../models/PDFNoteRefreshPage';

export class PDFNoteService extends BaseDataService<PDFNote, PDFNoteQuery> {
  protected prefixUrl: string = `PDFNotes`;

  save(data: PDFNote[]) {
    if (data.some(note => hasEmbeddedDataImage(note.Title))) {
      return this.api.post<PDFNote[]>(`${this.prefixUrl}/save`, data, withUploadRejectionDetection());
    }
    return super.save(data);
  }

  refreshPage(request: PDFNoteRefreshPageRequest, cancelToken?: CancelToken): AxiosPromise<PDFNoteRefreshPageResponse> {
    return this.api.post<PDFNoteRefreshPageResponse>(`${this.prefixUrl}/RefreshPage`, request, { cancelToken });
  }

  complete(noteId: number, comment: string) {
    const dto: NoteActionDto = {
      NoteId: noteId,
      Comment: comment
    };

    if (hasEmbeddedDataImage(dto.Comment)) {
      return this.api.post<PDFNote>(`${this.prefixUrl}/Complete`, dto, withUploadRejectionDetection());
    }
    return this.api.post<PDFNote>(`${this.prefixUrl}/Complete`, dto);
  }

  cancelCompletion(noteId: number) {
    return this.api.post<PDFNote>(`${this.prefixUrl}/CancelCompletion`, noteId);
  }

  downloadNewNotesRegistry(dto: DownloadNotesRegistryDto): AxiosPromise<Blob> {
    return this.api.post(
      `${this.prefixUrl}/DownloadNewNotesRegistry`,
      dto,
      { responseType: 'blob' }
    );
  }

}
